<template>
  <div>
    <cover :pageData="pageData"></cover>
    <div class="page">
      <div
        class="title"
        v-for="item in brandList"
        :key="item.id"
        v-show="tabIndex == item.id"
      >
        <div class="cn_title">{{ item.name }}</div>
        <div class="en_title">{{ item.englishName }}</div>
      </div>
      <div class="content">
        <div class="content_left">
          <div class="options_title">按业务分类</div>
          <div class="options">
            <div
              class="base_front"
              v-for="item in brandList"
              :key="item.id"
              :class="tabIndex == item.id ? 'blue' : 'gray'"
              @click="chooseOption(item.id)"
            >
              {{ item.name }}
              <div class="option_img" v-show="tabIndex != item.id">
                <img src=../assets/img/24x24_product_right_un@2x.png>
              </div>
              <div class="option_img" v-show="tabIndex == item.id">
                <img src=../assets/img/24x24_product_right@2x.png>
              </div>
            </div>
          </div>
        </div>
        <div class="content_right">
          <!-- 产品中心 -->
          <div class="products_box">
            <div class="noneBox" v-show="!pageList">
<!--              <img src="../assets/img/240x240_bg_default@2x.png" alt="" />-->
              <div class="noneFront">很抱歉，暂无更多内容~</div>
            </div>
            <ul class="products">
              <li
                v-for="item in pageList"
                :key="item.id"
                @click="toTrade(item.id)"
              >
                <div class="imgBox">
                  <img
                    class="product_img"
                    :src="img_api + item.images[0]"
                    alt=""
                  />
                </div>
                <div class="product_bottom">
                  <div class="blue_font">{{ item.englishName }}</div>
                  <div class="product_title">{{ item.name }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="pag" v-show="pageList">
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import cover from "../components/cover.vue";
import { getGoodPage } from "@/server/https.js";
export default {
  name: "",
  components: {
    cover,
  },
  data() {
    return {
      currentPage: 1, // 当前页码默认值为1
      pageSize: 6, // 每页显示条数默认值为10
      total: 0, // 数据总数
      img: "",
      tabIndex: 0,
      pageData: {
        firstTitle: "",
        secondTitle: "",
        bannerImg: "",
        des: "",
      },
      brandList: [],
      pageList: [],
      img_api: "https://www.gdyuanwo.com/gdyuanwo/",
      api: "http://192.168.31.41:7070/gpa/gpwx",
    };
  },
  mounted() {
    var setI = setInterval(() => {
      if (this.$store.state.headList != "") {
        var headList = this.$store.state.headList;
        headList.map((item) => {
          if (item.sort == 3) {
            let Name = item.name;
            this.pageData.firstTitle = Name.slice(0, -2);
            this.pageData.secondTitle = Name.substr(-2);
            this.pageData.bannerImg = item.image;
            this.pageData.des = item.details;
          }
        });
        clearInterval(setI);
      }
    }, 200);
    getGoodPage().then((res) => {
      this.tabIndex = res.data.body.brandList[0].id;
      res.data.body.brandList.sort((a, b) => a.sort - b.sort);
      this.brandList = res.data.body.brandList;
      getGoodPage({ brandId: this.tabIndex }).then((res) => {
        this.total = res.data.body.page.count;
        res.data.body.page.list.sort((a, b) => a.sort - b.sort);
        this.pageList = res.data.body.page.list;
      });
    });
  },
  methods: {
    //发请求获取tradeList数据
    chooseOption(index) {
      this.currentPage=1;
      this.tabIndex = index;
      this.getGoods();
    },
    getGoods() {
      getGoodPage({
        brandId: this.tabIndex,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.data.body.page.list) {
          res.data.body.page.list.sort((a, b) => a.sort - b.sort);
        }
        this.pageList = res.data.body.page.list;
        this.total = res.data.body.page.count;
      });
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getGoods();
    },
    toTrade(e) {
      this.$router.push({
        name: "TradeDetail",
        query: {
          goodId: e,
          tab: this.tabIndex,
        },
      });
    },
  },
};
</script>

<style scoped>
.page {
  /* display: flex; */
  /* justify-content: center; */
  position: relative;
  margin: auto;
}

.content {
  display: flex;
  margin-top: 180px;
  justify-content: center;
}

.content_left {
  overflow: hidden;
  width: 220px;
  margin-left: 70px;
}

.content_right {
  margin-left: 20px;
  width: 1200px;
  /* background-color: rgb(155, 250, 163); */
}

.title {
  display: flex;
  justify-content: center;
}

.cn_title {
  position: absolute;
  font-size: 48px;
  font-weight: bold;
  color: #13489d;
  margin-top: 56px;
  z-index: 2;
}

.en_title {
  position: absolute;
  font-size: 54px;
  font-weight: bold;
  color: #c8d4e1;
  margin-top: 56px;
}

.options {
  position: relative;
  background-color: #f7f8fa;
}

.options_title {
  width: 100%;
  padding: 10px;
  text-align: start;
  padding-left: 20px;
  line-height: 50px;
  background-color: #13489d;
  font-size: 22px;
  font-weight: bold;
  color: #ffffff;
}

.base_front {
  display: flex;
  padding-left: 20px;
  font-size: 18px;
  font-weight: 500;
  padding: 20px 0 20px 20px;
  border-bottom: 2px dashed #f7f8fa;
}

.gray {
  color: #333333;
}

.blue {
  color: #13489d;
}

.base_front:hover {
  cursor: pointer;
}

.option_img {
  position: absolute;
  right: 20px;
  width: 20px;
  height: 20px;
}

.option_img img {
  width: 100%;
  height: 100%;
}

.products_box {
  display: flex;
  flex-direction: column;
}

.products {
  display: flex;
  flex-wrap: wrap;
  height: 67.8%;
  /* width: 75%; */
  /* margin-top: 26px; */
  justify-content: start;
}

.products li {
  /* margin-top: 3%; */
  background: #f7f8fa;
  margin-left: 1.5%;
  margin-bottom: 3%;
  width: 332px;
    height: 305px;
  box-shadow: 4px 6px 16px 4px rgba(0, 0, 0, 0.1);
}

.products li:hover {
  cursor: pointer;
}

.imgBox {
  width: 94%;
  height: 75.3%;
  margin: 3%;
  /* border-bottom: 1px solid #C8D4E1; */
}

.product_img {
  width: 100%;
  height: 100%;
  display: flex;
}

.product_bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 17.44%;
  border-top: 1px solid #c8d4e1;
}

.blue_font {
  font-size: 16px;
  font-weight: bold;
  color: #13489d;
  border-bottom: 4px solid #ffd000;
}

.product_title {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-left: 2%;
}

.products_buttonBox {
  margin-top: 3%;
}

.product_button {
  display: flex;
  justify-content: center;
  width: 202px;
  height: 64px;
  background: #13489d;
  font-weight: 400;
  color: #ffffff;
  line-height: 64px;
  border: none;
}

.pag {
  float: right;
  margin-bottom: 40px;
  margin-right: 200px;
}
.noneBox {
  width: 25rem;
  height: 22rem;
  margin: auto;
}
.noneBox img {
  width: 100%;
  height: 100%;
}
.noneFront {
  text-align: center;
  margin-left: 34px;
  font-size: 16px;
}
</style>
